'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.themeParsing = themeParsing;
exports.themeColorLightness = themeColorLightness;
// These are the hexcodes of the Site Colors
var siteColorsArray = exports.siteColorsArray = ['e4e8eb', 'd6412f', 'e6145e', '9d1bb2', '6734ba', '3e4eb8', '3773db', '00bcd6', '008577', 'ffd000', 'ff9900', '7a5547', '737373'];

// Allows for backwards compatibility with channel themes as well as for the default theme.
function themeParsing(channelTheme) {
    switch (channelTheme) {
        case 'default':
            return 'default';
        case 'lgray':
            return '#e4e8eb';
        case 'red':
            return '#d6412f';
        case 'magenta':
            return '#e6145e';
        case 'purple':
            return '#9d1bb2';
        case 'violet':
            return '#6734ba';
        case 'dblue':
            return '#3e4eb8';
        case 'mblue':
            return '#3773db';
        case 'lblue':
            return '#00BCD6';
        case 'dgreen':
            return '#008577';
        case 'lgreen':
            return '#008749';
        case 'yellow':
            return '#ffd000';
        case 'orange':
            return '#ff9900';
        case 'brown':
            return '#7a5547';
        case 'gray':
            return '#737373';
        default:
            return channelTheme;
    }
}

// Looks at the lightness/darkness of the retrieved theme and returns a font color with contrast.
function themeColorLightness(channelTheme) {
    if (channelTheme) {
        var red = parseInt(channelTheme.substring(1, 3), 16) / 255;
        var green = parseInt(channelTheme.substring(3, 5), 16) / 255;
        var blue = parseInt(channelTheme.substring(5, 7), 16) / 255;
        var lightness = (Math.max(red, green, blue) + Math.min(red, green, blue)) / 2;
        return lightness > 0.5 ? '#040404' : '#ffffff';
    }
    return '#ffffff';
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/theme-selector-helper.js
// module id = 761
// module chunks = 0